import buttonForFolderIn from './buttonForFolderIn.vue'
export default buttonForFolderIn
